<template lang="pug">
  WtTile.wellnessChallengeQuestionsNotification(v-if="hasWellnessChallengeQuestion" parent vertical)
    WtTile.is-paddingless(child :col="12" v-for="question in activeWellnessChallengeQuestions" :key="question.id")
      BNotification(
        type="is-lightgrey"
        aria-close-label="Close active wellness question"
        v-if="showQuestionNotification(question)"
      )
        span.mr-3 You have an unanswered question in the {{ question.challengeName }} challenge.
        span
          a.has-text-blue(href="#" @click="activeQuestionOpen = true") Answer Now
      BModal(:active.sync="activeQuestionOpen" has-modal-card :key="question.id" @close="modalClosed")
        .modal-card
          header.modal-card-head
            p.modal-card-title Question: {{ question.challengeName }}
            WtIconButton.close-button(@click.native="modalClosed" aria-label="Close modal")
              BIcon(icon="close-circle" type="is-grey-light" size="is-medium")
          section.modal-card-body
            .is-size-6.pb-4
              p Answer the following to earn points in your active Wellness Challenge.
              p {{ question.pointValue }} points earned per question answered.
            .horizontal-divider
            .pb-4.editor__content.question-description(v-html="question.description")
            .horizontal-divider
            WtLabel.is-size-5(
              slot="label"
              :text="question.question"
            )
            QuestionAnswers(
              :question="question"
              @onAnswer="collectAnswer($event)"
              :show-answers="answerSaved"
            )

          footer.modal-card-foot.is-flex.is-justify-content-flex-end
            template(v-if="answerSaved")
              p Answer Saved
            template(v-else)
              WtButton(
                color="grey"
                isText
                @click.native="modalClosed"
              ) Cancel
              WtButton(
                @click.native="submitAnswer(question)"
                :disabled="disableSubmit || _.isEmpty(answerData)"
                :loading="answerSaving"
              ) Submit
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtIconButton from "@@/WtIconButton/WtIconButton";
import WtLabel from "@@/WtLabel/WtLabel";
import QuestionAnswers from "@@/ProgramQuestions/QuestionAnswers";

export default {
  name: "WellnessChallengeQuestionsNotification",

  components: {
    WtButton,
    WtTile,
    WtIconButton,
    WtLabel,
    QuestionAnswers
  },

  data() {
    return {
      answerData: null,
      activeQuestionOpen: false,
      disableSubmit: true,
      answerQuestionError: false,
      answerQuestionErrorMessage: null,
      answerSaved: false,
      answerSaving: false
    };
  },

  computed: {
    hasWellnessChallengeQuestion() {
      return !this._.isEmpty(this.activeWellnessChallengeQuestions);
    },
    activeWellnessChallengeQuestions() {
      return this.$auth
        .user()
        .challenges.filter(
          challenge => challenge.isWellness && challenge.questionActive
        )
        .map(challenge => {
          return {
            challengeId: challenge.id,
            challengeName: challenge.name,
            ...challenge.questionActive
          };
        });
    }
  },

  watch: {
    answerData(newValue) {
      if (!this._.isEmpty(newValue)) {
        this.disableSubmit = false;
      }
    },

    activeWellnessChallengeQuestions(newValue, oldValue) {
      // if there are multiple questions (currently business logic is to only allow for one wellness challenge but during testing there might be multiple :)
      // the api currently will only return the unanswered question so after submitting an answer we refresh that data via this.$auth.fetch()
      if (
        newValue.length < oldValue.length &&
        this.$route.name === "MyDashboard"
      ) {
        this.resetInitialState();
      }
    }
  },

  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("members", ["fetchMember"]),

    resetInitialState() {
      this.answerData = null;
      this.activeQuestionOpen = false;
      this.disableSubmit = true;
      this.answerQuestionError = false;
      this.answerQuestionErrorMessage = null;
      this.answerSaved = false;
      this.answerSaving = false;
    },

    collectAnswer($event) {
      this.answerData = $event;
    },

    async submitAnswer(question) {
      try {
        this.answerSaving = true;
        const response = await this.axios.post(
          `challenges/${question.challengeId}/answer-question`,
          {
            memberId: this.$auth.user().id,
            questionId: this.answerData.questionId,
            questionAnswer: this.answerData.answer
          }
        );
        this.answerSaved = !this._.isEmpty(response);
        this.snackBar({ message: "Your answer has been saved!" });
        this.answerSaving = false;
        this.disableSubmit = true;
      } catch (error) {
        this.answerQuestionError = true;
        this.answerQuestionErrorMessage = "";
      }
    },

    modalClosed() {
      this.activeQuestionOpen = false;
      this.$auth.fetch(); // refresh the active wellness questions
      this.fetchMember({
        memberId: this.$auth.user().id,
        setMember: true
      });
    },

    showQuestionNotification(question) {
      if (this.$route.name === "Challenge") {
        // this.$route.params.challengeId can be a string
        if (this.$route.params.challengeId != question.challengeId)
          return false;
      }
      return true;
    }
  }
};
</script>

<style lang="sass" scoped>
.modal-card
  max-height: 80vh
</style>
